<ins-cookie-settings-modal>
    <ins-cookie-settings-nl [hideClose]="true" />
    <ins-cookie-settings-buttons slot="footer" />
</ins-cookie-settings-modal>
